var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

var Card = function Card(_ref) {
  var className = _ref.className,
      props = _objectWithoutProperties(_ref, ["className"]);

  var prefixCls = "card";
  var componentCls = classnames(prefixCls, className);

  return React.createElement("article", _extends({ className: componentCls }, props));
};

export { Card };
Card.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string
} : {};

export default Card;


//////////////////
// WEBPACK FOOTER
// ../node_modules/@cxagroup/casper/es/components/card/card.js
// module id = null
// module chunks = 